more.menu = {
    // Funkcia, ktora nastavi tlacitko "Herny plan" a DOXXbet klub
    setProperties(terms, gdpr, bonuses, club, clubHomeButton, clubNew, clubCompetition) {
        try {
            // Ulozi do profilu aktualne udaje
            profile.Terms = terms;
            profile.GDPR = gdpr;
            profile.Bonuses = bonuses;
            profile.Club = club;
            profile.ClubHomeButton = clubHomeButton;
            profile.ClubNew = clubNew;
            profile.ClubCompetition = clubCompetition;

            // Stiahne properties - informacie o jazykovych mutaciach
            if (offer && offer.country && offer.lang) {
                delete profile.Properties;
                profile.Properties = new Object();

                // Defaulne nastavi Club, Terms a GDPR podla defualt mutacie
                profile.Properties.Bonuses = profile.Default.lang;
                profile.Properties.Club = profile.Default.lang;
                profile.Properties.Terms = profile.Default.lang;
                profile.Properties.GDPR = profile.Default.lang;

                more.menu.setBonuses(bonuses);
                more.menu.setClub(club, clubHomeButton, clubNew, clubCompetition);
                more.menu.setTerms(terms);
                more.menu.setGDPR(gdpr);

                var requestUrl;
                $.getJSON(requestUrl = url.base + "more/" + offer.country + "/properties.json")
                    .done(function (t) {
                        if (t.Lang[offer.lang]) {
                            profile.Properties = t.Lang[offer.lang];
                            if (profile.Properties.Bonuses != profile.Default.lang) more.menu.setBonuses(bonuses);
                            if (profile.Properties.Club != profile.Default.lang) more.menu.setClub(club, clubHomeButton, clubNew, clubCompetition);
                            if (profile.Properties.Terms != profile.Default.lang) more.menu.setTerms(terms);
                            if (profile.Properties.GDPR != profile.Default.lang) more.menu.setGDPR(gdpr);
                            return true;
                        }
                    })
                    // Ak sa subor nepodarilo stiahnut skusi stiahnut subor znova
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        clearTimeout(rfs.Properties);
                        rfs.Properties = setTimeout(function () {
                            more.menu.setProperties(terms, gdrp, bonuses, club, clubHomeButton, clubNew, clubCompetition);
                        }, sets.refreshTime);
                    });

            } else {
                more.menu.setBonuses(false);
                more.menu.setClub(false);
                more.menu.setTerms(false);
                more.menu.setGDPR(false);
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora nastavi tlacitko "Herny plan"
    setTerms(terms) {
        try {
            // Zobrazit herny plan
            if (terms && offer && offer.country) {
                $("#more #terms").attr("href", url.base + "more/" + offer.country + "/terms/terms_" + profile.Properties?.Terms + ".html").removeAttr("style");
                profile.Terms = true;
                return true;
            } else {
                $("#more #terms").hide();
                profile.Terms = false;
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora nastavi tlacitko "Herny plan"
    setGDPR(gdpr) {
        try {
            // Zobrazit herny plan
            if (gdpr && offer && offer.country) {
                $("#more #gdpr").attr("href", url.base + "more/" + offer.country + "/gdpr/gdpr_" + profile.Properties?.GDPR + ".html").removeAttr("style");
                profile.GDPR = true;
                return true;
            } else {
                $("#more #gdpr").hide();
                profile.GDPR = false;
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora nastavi tlacitko "Bonusy a akcie"
    setBonuses(bonuses) {
        try {
            if (bonuses && offer && offer.country && offer.lang) {
                // profile.Bonuses = bonuses;
                $("#more #bonuses").attr("href", url.base + "more/" + offer.country + "/bonuses/bonus_" + profile.Properties?.Bonuses + ".html").removeAttr("style");
                profile.Bonuses = true;
            } else {
                $("#more #bonuses").hide();
                profile.Bonuses = false;
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora nastavi tlacitko "DOXXbet klub"
    setClub(club, clubHomeButton, clubNew, clubCompetition) {
        try {
            // Zobrazit herny plan
            if (club && offer && offer.country && offer.lang) {
                if (profile.ClubLoyaltyCard) {
                    $("#more #club").attr("href", url.base + "more/" + offer.country + "/club/club_" + profile.Properties?.Club + ".html").removeAttr("style");
                }

                // Ulozi do profilu aktualne udaje
                profile.Club = club;
                profile.ClubHomeButton = clubHomeButton;
                profile.ClubNew = clubNew;
                profile.ClubCompetition = clubCompetition;

                // Nastavenie tlacitka na homeScreene (tlacidlo b)
                if (clubHomeButton) {
                    var competition = "", clubIcon = offer.country;
                    if (clubCompetition) {
                        competition = "competition-";
                        clubIcon = "empty";
                    }
                    if (profile.IsLoginRequired && profile.ClubLoyaltyCard && !profile.ClubDisplayVLC) {
                        // Ak sa vyzaduje RVO check (povodny parameter IsRvoCheckRequired sa zmenil na vseobecny IsLoginRequired) a sucasne sa nema zobrazovat info o registracii karty
                        profile.ClubPagesHide = [1];
                    }

                    // $("#homeButtons .ui-block-b").addClass("home-club-" + competition + offer.country)
                    // .html('<img class="home-icon home-icon-club" src="stylesheets/images/icon-club-' + clubIcon + '.png"><div class="home-button">'
                    // + (profile.ClubHomeButtonLabel? '<div id="loyalityLabel">' + texts.MoreClub + '</div>' : '') + '<span class="home-new"></span></div>');

                    // Zobrazenie ze pribudli v ramci klubu novinky, alebo je spustena lokalna sutaz
                    if (clubNew || clubCompetition) {
                        $("#homeButtons .ui-block-b .home-new").addClass("new-" + offer.lang);
                    } else if (profile.LocalCompetition) {
                        $("#homeButtons .ui-block-b .home-new").addClass("new-" + offer.lang + " competition-" + profile.LocalCompetition.toLowerCase());
                    }
                }

                profile.Club = true;
                return true;

            } else {
                // Schovat herny plan
                $("#more #club").hide();

                // Nastavenie tlacitka na homeScreene (tlacidlo b)
                $("#homeButtons .ui-block-b").removeClass("home-club-" + offer.country)
                    .html('<img class="home-icon" src="stylesheets/images/icon-lastMinute.png"><div class="home-button icon-alarm"><div>'
                        + texts.FooterLabelLastMinute + '</div></div>');
                profile.Club = false;
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na ziskanie rebricka hracov vernosneho programu
    clubStats(rankingName, page, index) {
        try {
            if (rankingName) {
                // Volitelny parameter "Player" vrati poziciu prihlaseneho hraca
                var player = -1;
                if (stored.PlayerID) player = stored.PlayerID;

                // Najprv zobrazi aj neaktualny rebricek
                if (stored.ClubStats[rankingName]) more.menu.clubStatsRender(rankingName, page, index);

                // Ak treba tak stiahne a vyrenderuje novy rebricek
                if (!stored.ClubStats[rankingName] || !stored.ClubStats.validity[rankingName] || stored.ClubStats.validity[rankingName] < new Date()) {
                    var requestUrl;
                    $.getJSON(requestUrl = "https://loyality-ws-" + offer.country + ".doxxbet.sk/Loyality.svc/" + rankingName + "/Player/" + player + "/Zone/" + offer.zone + "/SBID/" + stored.SBID + "?callback=?")
                        .done(function (o) {
                            // Nastavenie platnosti stiahnuteho rebricka a jeho zobrazenie
                            stored.ClubStats[rankingName] = o;
                            stored.ClubStats.validity[rankingName] = new Date(new Date().getTime() + offer.cacheValidity);
                            more.menu.clubStatsRender(rankingName, page, index);
                            return true;
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            return false;
                        });
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na renderovanie rebricka hracov vernosneho programu
    clubStatsRender(rankingName, page, index) {
        try {
            var o = stored.ClubStats[rankingName];

            // DOXXbet Klub
            if (page) {
                if (profile.ClubCompetitionIDs && profile.ClubCompetitionIDs.length) {
                    actualRankingName = stored.ClubStats[index];
                } else {
                    actualRankingName = stored.ClubStats[index];
                }
                // Pripadna zmena pozadia pre hlavnu sutaz (defaultne je Prepared)
                if (o.CampaignStatus && rankingName == actualRankingName) {
                    var prefix = "";
                    // 'flat-' prexit pre nazov obrazku hlavnej sutaze
                    if (profile.FlatCSS) prefix = "flat-";

                    $("#doxxbetClub #paragraph" + page + " img").attr("src", "background-" + profile.Properties?.Club + "/" + prefix + "club-month-" + o.CampaignStatus + ".jpg");
                    $("#clubCompetitionWinners").show();

                    // Natvrdo pretazeny typ a status rebricka (testovanie)
                    // if (stored.ClubStats.RankingType) o.RankingType = stored.ClubStats.RankingType;
                    // if (stored.ClubStats.CampaignStatus) o.CampaignStatus = stored.ClubStats.CampaignStatus;
                }

                // Rebricky zobrazi len ak sa nejedna o sutaz alebo sutaz je v inom stave ako Prepared
                if (o.CampaignStatus != "Prepared") {

                    // Ak sa hra o priceMoney
                    if (o.PriceMoney) {
                        $("#doxxbetClub #paragraph" + page + " #clubPotWinPlayers").text(o.PlayerCount);
                        var potWin;
                        if (o.PriceSplitPlayers && o.PlayerCount) {
                            if (o.PriceMoney < o.PlayerCount) {
                                potWin = shared.floor2(o.PriceMoney / o.PlayerCount);
                            } else {
                                potWin = Math.floor(o.PriceMoney / o.PlayerCount);
                            }
                        } else {
                            potWin = Math.ceil(o.PriceMoney);
                        }
                        $("#doxxbetClub #paragraph" + page + " #clubPotWinAmount").html(potWin + '<span>' + profile.Currency + '</span>');
                    }

                    // Rebricek
                    if (o.Rankings.length || o.RankingType == "3-tickets") {
                        var i = 0, rp, dt = "",
                            rankingTable = '<table cellpadding="0" cellspacing="4"><caption>' + texts.Ranking
                                + '</caption><p></p><thead><tr><th></th><th></th><th class="head-rank">';

                        // Nastavi rankingType
                        switch (o.RankingType) {
                            case "Rate":
                                rankingTable += texts.RankingRate;
                                break
                            case "Points":
                                rankingTable += texts.RankingPoints;
                                break;
                            case "Tickets":
                                rankingTable += texts.RankingTickets;
                                break;
                        }
                        rankingTable += '</th></tr></thead><tbody>';

                        var ticketActive, ticketNone = "";
                        if (o.RankingType == "3-tickets") {
                            ticketActive = '<img src="' + url.base + 'stylesheets/images/icon-ticket-active.png"></img>';
                            ticketNone = '<img src="' + url.base + 'stylesheets/images/icon-ticket-none.png"></img>';
                        }
                        // if (page == 10) {
                        //     if (rankingName === "Competition-106")
                        //         stored.ClubStats[rankingName].advantage = ['iPhone 12 Pro Max', 'iPhone 12', 'iPhone SE 2020'];
                        //     if (rankingName === "Competition-107")
                        //         stored.ClubStats[rankingName].advantage = ['iPhone 12 Pro Max'];
                        // }
                        $.each(o.Rankings, function (i, player) {
                            if (player.RequestedPlayer) {
                                rp = ' class="requested-player"';
                            } else {
                                rp = '';
                            }
                            rankingTable += '<tr' + rp + '><td class="table-rank">';
                            if (player.Position) rankingTable += player.Position + '.';
                            if (!player.Name) player.Name = '<span class="empty-name">' + texts.Club_EmptyName + '</span>';
                            rankingTable += '</td><td class="table-name">' + player.Name + '</td>';
                            if (o.RankingType == "3-tickets") {

                                if (player.Points == 0) {
                                    rankingTable += '<td>' + ticketNone + '</td><td>' + ticketNone + '</td><td>' + ticketNone + '</td>';
                                } else if (player.Points == 1) {
                                    rankingTable += '<td>' + ticketActive + '</td><td>' + ticketNone + '</td><td>' + ticketNone + '</td>';
                                } else if (player.Points == 2) {
                                    rankingTable += '<td>' + ticketActive + '</td><td>' + ticketActive + '</td><td>' + ticketNone + '</td>';
                                } else if (player.Points >= 3) {
                                    rankingTable += '<td>' + ticketActive + '</td><td>' + ticketActive + '</td><td>' + ticketActive + '</td>';
                                }

                                if (player.RequestedPlayer) {
                                    rankingTable += '<div class="rank-line"></div>';
                                    if (player.Points < 3) {
                                        rankingTable += '<div class="more-tickets">' + texts["Club_moreTickets_" + (3 - player.Points)] + '</div>'
                                            + '<div class="rank-arrow-up"><img src="' + url.base + 'stylesheets/images/icon-arrow-up.png"></img></div>';
                                    } else {
                                        rankingTable += '<div class="congratulation">' + texts.Club_Congratulation + '</div>';
                                    }
                                }

                            } else if (o.RankingType && o.RankingType != "List")
                                if (o.RankingType != "Rate") {
                                    rankingTable += '<td class="table-points">' + player.Points;
                                    if (player.Rate) rankingTable += ' (' + texts.RankingRate.toLowerCase() + ' ' + shared.floor2(player.Rate, 2) + ')';
                                    rankingTable += '</td>';
                                } else {
                                    rankingTable += '<td class="table-rate"><span class="icon-star"></span>' + shared.floor2(player.Rate, 2) + '</td>';
                                }
                                if (page == 10 && stored.ClubStats[rankingName].advantage && stored.ClubStats[rankingName].advantage[i])
                                rankingTable += '<td class="table-advantage"><span>' + stored.ClubStats[rankingName].advantage[i] + '</span></td>';

                            rankingTable += '</tr>';
                        });


                        rankingTable += '</tbody></table>';

                        // Cas kedy bol rebricek generovany
                        if (o.Generated) dt = o.Generated.substr(8, 2) + "." + o.Generated.substr(5, 2) + "." + o.Generated.substr(0, 4) + "  " + o.Generated.substr(11, 5);

                        // Renderovanie do konkretnej podstranky
                        if (page == 10) {
                            $("#doxxbetClub #paragraph" + page + " #clubTable" + o.Description).html(rankingTable).children("p").text(dt);
                        } else {
                            $("#doxxbetClub #paragraph" + page + " .club-table").html(rankingTable).children("p").text(dt);
                        }
                    }

                    // Extra rebricek
                    if (o.ExtraRanking) {
                        rankingTable = '<thead><tr class="head-rank-day"><th></th><th>' + texts.RankingDay
                            + '</th><th></th></tr></thead><tbody><tr><td></td><td class="table-name">' + o.ExtraRanking.Name + '</td>';

                        if (o.RankingType != "Rate") {
                            rankingTable += '<td class="table-points">' + o.ExtraRanking.Points + '</td>';
                        } else {
                            rankingTable += '<td class="table-rate">' + shared.floor2(o.ExtraRanking.Rate, 2) + '</td>';
                            // RankingTickets
                        }
                        rankingTable += '</tr></tbody>';

                        // Renderovanie extra rebricka
                        $("#doxxbetClub #paragraph" + page + " .club-table table").append(rankingTable);
                    }

                    // Spusti custom script pre MainCompetition
                    if (stored.ClubStats[profile.ClubPageCompetition]) {
                        try {
                            clubMainCompetitionScript();
                            return true;
                        } catch (e) {
                            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                            return false;
                        }
                    }
                }

            } else {

                // GoldenLeague
                if (rankingName == "Competition-Expert") {
                    $("#sectionTop.golden-league-top .golden-league-jackpot div")
                        .html(Math.ceil(stored.ClubStats[rankingName].PriceMoney) + "<span>" + profile.Currency + "</span>")
                }
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecujuca prepinanie stranok v DOXXbet klube
    clubPage(page) {
        try {
            var p;
            // TODO - tu sa prepina class na ktivne tlacidlo
            $("#doxxbetClub .register-buttons a").removeClass("non-ui-btn-active");
            if (p = parseInt(page)) {
                $("#doxxbetClub #clubPage" + p).addClass("non-ui-btn-active");
            } else {
                $("#doxxbetClub #clubPage" + page).addClass("non-ui-btn-active");
            }
            $("#doxxbetClub .club-page").hide();
            if ($("#doxxbetClub #paragraph" + page).removeAttr("style").hasClass("show-scrollbar")) {
                $("#doxxbetClub").addClass("show-scrollbar").find(".arrows").show();
                $("#clubContent").scrollTop(0);
            } else {
                $("#doxxbetClub").removeClass("show-scrollbar").find(".arrows").hide();
            }
            // Zobrazenie konkretneho rebricka na konkretnej podstranke
            if (profile.ClubCompetitionIDs && profile.ClubCompetitionIDs.length && page == 10) {
                profile.ClubCompetitionIDs.forEach(function(cmp, index) {
                    more.menu.clubStats(stored.ClubStats[page + '-' + index], page, page + '-' + index);
                });
            } else {
                more.menu.clubStats(stored.ClubStats[page], page);
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.closeDialog();
            return false;
        }
    },

    // Funkcia zabezpecujuca prepinanie stranok v bonusoch
    bonusPage(page, bonusName, renderStateButton, iframeData, iFrameProgressUrl) {
        try {
            var p;
            $("#bonuses .register-buttons a").removeClass("non-ui-btn-active");
            if (p = parseInt(page)) {
                $("#bonuses #clubPage" + p).addClass("non-ui-btn-active");
            } else {
                $("#bonuses #clubPage" + page).addClass("non-ui-btn-active");
            }
            $("#bonuses .club-page").hide();
            if ($("#bonuses #paragraph" + page).removeAttr("style").hasClass("show-scrollbar")) {
                $("#bonuses").addClass("show-scrollbar").find(".arrows").show();
                $("#clubContent").scrollTop(0);
            } else {
                $("#bonuses").removeClass("show-scrollbar").find(".arrows").hide();
            }

            if (renderStateButton && stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                stored.bonusIndexToOpen = 0;
                var bonusMenu = [{
                    bonusName: bonusName,
                    iFrameProgressUrl: iFrameProgressUrl
                }];
                var stateButton = $("<a id='showMyState' data-role='none' class='non-ui-btn'>" + texts.ContentBonusMyState + "</a>")
                    .attr("onmousedown", "player.playerBonusModule.playerBonusesFromMarketingSubPage(" + page + ", '" + bonusName + "')")
                    .data("menuData", bonusMenu)
                    .data("iframeData", iframeData);
                $("#bonuses #clubContent #paragraph" + page).append(stateButton).trigger("create");
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.closeDialog();
            return false;
        }
    },

    // Funkcia zabezpecujuca prepinanie stranok v napovede
    termsPage(page, scan) {
        try {
            $("#doxxbetTerms .register-buttons a").removeClass("non-ui-btn-active");
            $("#doxxbetTerms #termsPage" + page).addClass("non-ui-btn-active");
            $("#doxxbetTerms .terms-page").hide();
            if (profile.FlatCSS) $("#doxxbetTerms .arrows").removeClass('flat-arrows-left-right');
            if (!scan) {
                $("#doxxbetTerms #paragraph" + page).removeAttr("style");
                $("#termsContent").scrollTop(0);
                if (profile.Properties.TermsScanActive) {
                    delete profile.Properties.TermsScanActive;
                    $("#doxxbetTerms #termsContent").removeClass("scan-preview");
                    $("#doxxbetTerms #termsPageUp").attr("onmousedown", "shared.scrollModule.scrollPage('terms',-600,'slow');");
                    $("#doxxbetTerms #termsPageDown").attr("onmousedown", "shared.scrollModule.scrollPage('terms',600,'slow');");
                }
                if (profile.FlatCSS) shared.scrollModule.scrollButtons("terms-page", null, page);

            } else if (profile.Properties) {
                $('#termsDate').show();
                more.menu.termsScan(page);
                profile.Properties.TermsScanActive = true;
                $("#doxxbetTerms #termsContent").addClass("scan-preview");
                $("#doxxbetTerms #termsPageUp").attr("onmousedown", "more.menu.termsScan('" + page + "','prev');");
                $("#doxxbetTerms #termsPageDown").attr("onmousedown", "more.menu.termsScan('" + page + "','next');");
                $("#doxxbetTerms #paragraphScan").removeAttr("style");
                if (profile.FlatCSS) {
                    // V hernom plane nastavi posuvne sipky vlavo/vpravo pre obsah scan dokumentu
                    $("#doxxbetTerms #paragraphScan h2").html($("#doxxbetTerms .non-ui-btn-active").text());
                    $("#doxxbetTerms .arrows").removeClass("flat-arrows-left-right");
                    var key = page + "Pages";
                    if (profile.Properties[key] > 2) {
                        $("#doxxbetTerms .arrows").addClass("flat-arrows-left-right").show();
                    } else {
                        $("#doxxbetTerms .arrows").hide();
                    }
                }
            }
            $('#termsDate #secondDate').empty().hide();
            switch (page) {
                case "Terms":
                    // HP (od 1.1.2025 bez dodatkov)
                    $('#termsDate #firstDate').text(texts.GamePlaneApproved + ' ' + stored.Allowance.gamePlanOriginal.date);
                    break;
                case "Directive":
                    // Interna smernica
                    $('#termsDate #firstDate').text(texts.Approved + ' ' + stored.Allowance.internDirections.date);
                    break;
                case "Additional":
                    // Prevadzkove pravidla
                    $('#termsDate #firstDate').text(texts.Approved + ' ' + stored.Allowance.termsPageAdditional.date);
                    break;
                default:
                    // HP
                    $('#termsDate #firstDate').text(texts.Approved + ' ' + stored.Allowance.gamePlanOriginal.date);
                    break;
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.closeDialog();
            return false;
        }
    },

    // Zobrazenie strany skenu herneho planu alebo ineho dokumentu a listovanie v nom
    termsScan(page, pageAction) {
        try {
            if (profile.Properties && profile.Properties[page + "Pages"]) {
                var pathPage, secondPage;
                if (page == "GDPR") {
                    pathPage = "./more/" + offer.country + "/gdpr/gdpr-form-" + profile.Properties[page + "Lang"] + "/";
                } else {
                    pathPage = "./more/" + offer.country + "/terms/" + page.toLowerCase() + "-" + profile.Properties[page + "Lang"] + "/";
                }
                if (profile.Properties[page + "Pages"] == 1) {
                    profile.Properties.ActualPage = 1;
                    $("#doxxbetTerms #scanPageRight").hide();
                    $("#doxxbetTerms #scanPageLeft").addClass("scanPageCenter");
                    $("#doxxbetTerms #scanPageLeft h3").empty();
                    $("#doxxbetTerms #scanPageLeft img").attr("src", pathPage + profile.Properties.ActualPage + ".jpg");
                } else {
                    if (!pageAction || !profile.Properties.ActualPage) {
                        profile.Properties.ActualPage = 1;
                        secondPage = 2;
                    } else {
                        if (pageAction == "next") {
                            if (++profile.Properties.ActualPage > profile.Properties[page + "Pages"]) {
                                profile.Properties.ActualPage = 1;
                                secondPage = 2;
                            } else {
                                if ((secondPage = profile.Properties.ActualPage + 1) > profile.Properties[page + "Pages"]) secondPage = 1;
                            }
                        } else if (pageAction == "prev") {
                            if ((secondPage = profile.Properties.ActualPage--) == 1) profile.Properties.ActualPage = profile.Properties[page + "Pages"];
                        }
                    }
                    $("#doxxbetTerms #scanPageLeft").removeAttr("class");
                    $("#doxxbetTerms #scanPageLeft h3").html(profile.Properties.ActualPage + " / " + profile.Properties[page + "Pages"]);
                    $("#doxxbetTerms #scanPageLeft img").attr("src", pathPage + profile.Properties.ActualPage + ".jpg");
                    $("#doxxbetTerms #scanPageRight h3").html(secondPage + " / " + profile.Properties[page + "Pages"]);
                    $("#doxxbetTerms #scanPageRight img").attr("src", pathPage + secondPage + ".jpg");
                    $("#doxxbetTerms #scanPageRight").show();
                }
    
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na dotiahnutie aktualnych podstranok v bonusoch
    getBonusList(tileData, forceOpen) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.centralSB + "/bonus/bonus-list?forPlatform=" + offer.platform + "&isForMarketingSite=true&languageId=" + offer.bonusesLang)
                .done(function (bonusListData) {
                    if (bonusListData === Object(bonusListData)) {
                        clearTimeout(rfs.bonusList);
                        rfs.bonusList = null;
                        more.menu.assignBonusData(tileData, bonusListData, forceOpen);
                    } else {
                        main.createLog(2, "CentralSportboxBonusList_Failed", " # AJAX FAILED: not-object");
                    }
                })
                // Ak sa bonus list nepodarilo stiahnut skusi ho stiahnut znova
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralSportboxBonusList_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                    clearTimeout(rfs.bonusList);
                    rfs.bonusList = setTimeout(function() {
                        more.menu.getBonusList(tileData, forceOpen);
                    }, sets.refreshTime);
                });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zmenu obrazka dlazdice a k nemu priradenie marketingovej bonusovej podstranky
    assignBonusData(tileData, bonusListData, forceOpen) {
        try {
            if (tileData) {
                profile.TileInfo = tileData;
            }
            if (bonusListData && bonusListData.length) {
                profile.BonusList = bonusListData.sort(function(blA, blB) {
                    return blA.recordOrder - blB.recordOrder;
                });

                if (profile.TileInfo && profile.TileInfo.bonusName && profile.BonusList) {
                    // Zistenie poradia podstranky
                    stored.bonusIndexToOpen = more.menu.assignBonusSubPageMenu(profile.BonusList, profile.TileInfo.bonusName, "bonusName");
                    // zaznamenam to aj ako data atribut do tlacidla lebo sa to v kode resetuje, napr. pri zobrazeni podstranky bonusov
                    $("#homeButtons .ui-block-b .home-button").attr("data-bonus-index", stored.bonusIndexToOpen);
                } else {
                    // Nezadane bonus name v betmanagery
                    stored.bonusIndexToOpen = profile.BonusOpenDefault;
                }

                if (profile.TileInfo.imageUrl) {
                    // Kym niesu implementovane automaticke bonusy, zostava priznak profile.ClubHomeButton ako prepinac medzi zacinajucimi zapasmi/aktualnym bonusom
                    profile.ClubHomeButton = true;
                    // Vymeni dlazdicu
                    $("#homeButtons .ui-block-b .home-icon").remove();
                    $("#homeButtons .ui-block-b .home-button").removeClass("icon-alarm").empty().attr("style", "background: url(" + profile.TileInfo.imageUrl + "), url(" + profile.GraphicSportboxURL + "/cards/flat-club-default.jpg" + ")");
                }

                if (forceOpen) {
                    openBonusSubPage(forceOpen);
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vracia zistene poradie marketingovej podstranky na zaklade bonusName property
    assignBonusSubPageMenu(list, navToOpen, holdingParam) {
        try {
            if (list && navToOpen && holdingParam) {
                var bonusIndexToOpen = list.findIndex(function(blSorted) {
                    return (blSorted[holdingParam] === navToOpen);
                });
                if (typeof bonusIndexToOpen === "number" && bonusIndexToOpen !== -1) {
                    return String(bonusIndexToOpen);
                }
                return 0;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    legalDocs: {
        // Funkcia na zobrazenie dokumentov ("gdpr", "terms")
        // volana z nativky prostrednictvom showDocument(documentName) - momentalne len pri onboardingu
        show: function (documentName) {
            try {
                main.userAction();
                if (documentName) {
                    switch (documentName) {
                        // main.openPage() bud vrati true alebo false
                        // ak sa podarilo otvorit stranku, tak je to true, inak false a prejde na ponuku
                        case "gdpr":
                            profile.ConsoleLog && console.warn("more.menu.legalDocs.show() - gdpr document shown");
                            main.openPage('gdpr');
                            break;
                        case "terms":
                            profile.ConsoleLog && console.warn("more.menu.legalDocs.show() - terms document shown");
                            main.openPage('terms');
                            break;
                        default:
                            profile.ConsoleLog && console.warn("more.menu.legalDocs.show() - unknown document name: " + documentName);
                            // nativka poslala zly nazov dokumentu
                            return false;
                    }
                } else {
                    // nativka neposlala ziadny dokument
                    profile.ConsoleLog && console.warn("more.menu.legalDocs.show() - no document name provided");
                    return false;
                }
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments), e);
                return false;
            }
        },
        // Funkcia sluzi na oznamenia zatvorenia dokumentov pri onboardingu
        hidden: function (documentId) {
            try {
                switch (documentId) {
                    case "closeGDPR":
                    case "closeTerms":
                        // funkcia registrovana v nativke ktorou oznamujem zatvorenie dokumentu vo webapp aby sa zobrazil spravny screen z nativky
                        if (player?.onboarding?.inProgress) {
                            profile.ConsoleLog && console.warn("more.menu.legalDocs.hidden() => OnboardingDocumentsHidden(false) - onboarding documents hidden");
                            OnboardingDocumentsHidden(false);
                        }
                        break;
                    case "watcherTimeout":
                        // funkcia registrovana v nativke ktorou oznamujem zatvorenie dokumentu vo webapp aby sa zobrazil spravny screen z nativky
                        if (player?.onboarding?.inProgress) {
                            profile.ConsoleLog && console.warn("more.menu.legalDocs.hidden() => OnboardingDocumentsHidden(true) - onboarding documents hidden by timeout");
                            OnboardingDocumentsHidden(true);
                            player.onboarding.stop();
                        }
                        break;
                    default:
                        profile.ConsoleLog && console.warn("more.menu.legalDocs.hidden() - just default, no action - unknown documentId: " + documentId);
                        break;
                }
                if (player.onboarding.playerIsViewingLegalDocs) {
                    // Pri zatvarani dokumentov zrusim timeout a nastavim priznak ze hrac uz nepozerá legal docs
                    clearTimeout(rfs.ticketWatcher);
                    rfs.ticketWatcher = null;
                    player.onboarding.playerIsViewingLegalDocs = false;
                }
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments), e);
                return false;
            }
        }
    },

    // Funkcia volana z nativky na zobrazenie dokumentov ("gdpr", "terms")
    // momentalne len pri onboardingu
    showDocument(documentName) {
        profile.ConsoleLog && console.warn("showDocument() - documentName: " + documentName);
        // Nastavim priznak ze hrac pozerá legal docs
        player.onboarding.playerIsViewingLegalDocs = true;
        more.menu.legalDocs.show(documentName);
    }

};
